import { CdkDragDrop,
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, ElementRef, Input, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { Service } from "../../models/service";
import { ServiceControllerService } from "../../services/service-controller/service-controller.service";
import { ServiceCategoryControllerService } from "../../services/service-categories-controller/service-category-controller.service";
import { Store } from "../../services/store.service";
import { SystemProperties } from "../../models/system-properties";
import { SendFileFormControllerService } from "../../services/form-controller/sendfile-form-controller.service";
import { SystemPropertiesControllerService } from "../../services/system-settings/system-properties-controller.service";
import { ServiceCopyControllerService } from "../../services/service-controller/service-copy-controller.service";
import {TranslateService} from "@ngx-translate/core";
import {TranslatedBaseError} from "../pages/TranslatedBaseError";
import { ServiceCategory } from "../../models/service-category";
import {BaseForm} from "../../models/base-form";
import {TutorialBase} from "../../models/tutorial-base";
import { environment } from "../../../environments/environment";
import { GuideTypesEnum } from "../../models/guideTypes";
import { ServiceProperties } from "../../models/service-properties";
import { ServiceAddComponent } from "./add-service/service-add.component";
import { ServiceCopyModalComponent } from "../pages/service-detail/service-copy-modal.component";
import { ServiceGroupControllerService } from "src/app/services/service-group-controller/service-group-controller.service";
import { ServiceGroup } from "src/app/models/service-group";
import { map } from "rxjs/operators";

@Component({
  selector: "service-select-panel",
  templateUrl: "./service-select-panel.component.html",
  styleUrls: ["./service-select-panel.component.css"],
  providers: [SendFileFormControllerService],
})
export class ServiceSelectPanelComponent extends TranslatedBaseError implements OnInit {

  @Input() public wrapperCssClass: string;
  @Input() public reloadServices = false;
  @Input() public nameFieldKey = "name";
  @Input() public userId: string;
  public guideTypesEnum = GuideTypesEnum;
  public guideTypesOptions = [];
  public serviceDropdownClicked: boolean;
  public newService: Service = new Service();
  public selectedService: Service;
  public isNewServiceLoading: boolean = false;
  public isAddDeterminantShown = false;
  public addNew: boolean = false;
  public services: Service[];
  public servicePublisher: string;
  public showWarningModal = false;
  public selectedServiceTitle = "Loading...";
  public searchTextFilterObject: any;
  public searchValue: string = "";
  public filteredUser: string = "";
  public serviceName: { value: string } = { value: "" };
  public showAddComponent: boolean = false;
  public showCopyServiceModal: boolean = false;
  // Sort variables
  public sortKey: string = "";
  public ascending: boolean = false;
  public resetSort: boolean = false;
  public archived: boolean = false;
  public showTutorial: boolean = false;
  public showExternalinList: boolean = false;
  public showReleaseNotes: boolean = false;
  public showFilters: boolean = false;
  public systemProperties: SystemProperties;
  public pageTutorials: {[key: string]: string};
  public externals: number = 0;

  public servicesGroups: ServiceGroup[] = [];

  public dragInProgress = false;

  public selectedReleaseNotes: any;

  public isAcatSelected: any;

  public selectedCat: string = "all";

  public allCategories: ServiceCategory[];

  public filteredUserServices: boolean = false;
  public showOnlyHighlightedServices: boolean = false;

  public showExternalServersColumn: boolean = true;

  public blob: any;

  public defaultMyAccountServiceId: string;

  @ViewChild(ServiceAddComponent) public serviceAddComponent: ServiceAddComponent;
  @ViewChild(ServiceCopyModalComponent) public serviceCopyModal: ServiceCopyModalComponent;

  @ViewChild("newServiceNameInput")
  public newServiceNameInput: ElementRef;

  constructor(private serviceControllerService: ServiceControllerService,
              private sendFileFormControllerService: SendFileFormControllerService,
              private systemPropertiesControllerService: SystemPropertiesControllerService,
              private serviceCategoryControllerService: ServiceCategoryControllerService,
              private serviceCopyControllerService: ServiceCopyControllerService,
              public serviceGroupControllerService: ServiceGroupControllerService,
              private router: Router,
              public store: Store,
              public toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);

  }

  public ngOnInit() {
    this.initTutorials();
    document.getElementsByTagName("body")[0].classList.add("services-list");
    const isUserFiltered = localStorage.getItem("filteredUser");
    if (isUserFiltered && (isUserFiltered === this.userId)) { this.filterUserServices(); }
  }

  public ngOnDestroy() {
    document.getElementsByTagName("body")[0].classList.remove("services-list");
  }

  public initCopy() {
    this.serviceCopyModal.copy();
  }

  public initTutorials() {
    this.systemPropertiesControllerService.getServiceProperties().subscribe(
      (data) => {
        this.systemProperties = data;
        this.systemProperties = Object.assign(new SystemProperties(), data);
        this.systemProperties.tutorials = Object.assign(new TutorialBase().tutorials, this.systemProperties.tutorials);
        if (!this.systemProperties.tutorials.services) {
          Object.assign(this.systemProperties.tutorials, TutorialBase.addProperty("services"));
        }
        this.pageTutorials = this.systemProperties.tutorials.services;
        // console.log(this.systemProperties);
        this.initServices();
      },
      (error) => {
        this.pageTutorials = {};
        this.initServices();
        return this.showErrorMessageWithTitle("Error getting system properties", error);
      },
    );
  }

  public saveServiceAdd() {
    // console.log("--- saveServiceAdd  ---");
    this.serviceAddComponent.submit();
  }

  public downloadServiceJson(event: any, service: any) {
    if (event.save && event.properties) {
      const serviceCopyProperties = event.properties;
      this.serviceCopyControllerService.exportServiceWithProperties(service.id, serviceCopyProperties).subscribe(
        (data) => {
          this.blob = new Blob([data], { type: "application/octet-stream" });
          const downloadURL = window.URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = downloadURL;
          link.download = "service_" + event.properties.newServiceName + ".json";
          link.click();
        },
        (error) => this.showErrorMessage(error),
      );
      this.showCopyServiceModal = false;
    }
    if (event.delete || event.cancel) {
      this.showCopyServiceModal = false;
    }
  }

  public closeExport() {
    this.showCopyServiceModal = false;
    this.selectedService = null;
  }

  public openExport(service) {
    this.selectedService = service;
    this.showCopyServiceModal = true;
  }

  public filterUserServices() {
    this.filteredUserServices = !this.filteredUserServices;
    if (this.filteredUserServices) {
      this.filteredUser = String(this.userId);
      localStorage.setItem("filteredUser", this.userId);
    } else {
      this.filteredUser = null;
      localStorage.removeItem("filteredUser");
    }
  }

  public droppedGroup(event: CdkDragDrop<ServiceGroup[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      // console.log("--- reordered groups", this.servicesGroups);
      this.updateGroupsOrder();
    }
  }

  public updateGroupsOrder() {
    const promises = [];
    this.servicesGroups.forEach((g, index) => {
      g.sortOrder = index;
      if (g.id) {
        promises.push(
          this.serviceGroupControllerService.updateGroup(g).pipe(map((data) => {
            return data;
          })).toPromise(),
        );
      }
    });
    Promise.all<any[]>(promises).then((results: any[]) => {
      this.responseSuccessful("Groups reordered!");
    });
  }

  public dropped(event: CdkDragDrop<Service[]>, group) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

      group.services.forEach((service, index, servicesArray) => {
        servicesArray[index].sortOrder = index;
      });
      this.updateSortOrder(group.services, "Services reordered!");
    } else {
      const movedService = this.services.find((s) => s.id === event.item.data.id);
      if (movedService) {
        movedService.serviceGroup = group;
        movedService.sortOrder = event.currentIndex;
        if (!group.status) {
          this.toggleGroupStatus(group);
        }
        this.serviceControllerService.saveService(movedService, null).subscribe(
          () => {
            this.responseSuccessful("Service moved!");
            this.initServices();
          },
          (error) => {
            this.showErrorMessage(error);
            this.initServices();
          },
        );
      }
    }
  }

  getAllGroupsExceptCurrent(current) {
    const groups = this.servicesGroups.filter((g) => { return g.id !== current; });
    const allgroups = [];
    groups.forEach((group) => {
      allgroups.push(`service-group-${group.id}`);
    });
    return allgroups;
  }

  public onServiceDragStarted() {
    this.dragInProgress = true;
  }

  public onServiceDragEnded() {
    this.dragInProgress = false;
  }

  public saveTutorial(e: any) {
    this.systemProperties.tutorials.services = this.pageTutorials;
    // console.log(this.pageTutorials, this.systemProperties);
    this.systemPropertiesControllerService.createCServiceProperties(this.systemProperties).subscribe(
      (data) => {
        return this.responseSuccessful("Tutorial saved!");
      },
      (error) => {
        return this.error(error, "Tutorial not saved!");
      },
    );
  }

  public createService() {
    if (!this.isNewServiceLoading) {
      this.serviceName.value = this.searchValue;
      this.newService.name = this.serviceName.value;
      this.newService.sortOrder = -1;
      this.showAddComponent = true;
    }
  }

  public openEdit(s) {
    if (!this.isNewServiceLoading) {
      this.newService = s;
      this.showAddComponent = true;
    }
  }

  public closeAdd() {
    this.showAddComponent = false;
    this.newService = new Service();
  }

  public serviceFromSlider(remoteService) {
    this.isNewServiceLoading = true;
    this.showAddComponent = false;
    this.newService = remoteService;
    if (this.newService.id) {
      this.updateService(this.newService, "Service edited!");
    } else {
      this.createServiceRequest();
    }
  }

  public createServiceRequest() {
    this.serviceControllerService.addService(this.newService).subscribe(
      (data: Service) => {
        const id = data.id;
        this.sendFileFormControllerService.getSendFileForm(id, false).subscribe(
          (file: BaseForm) => {
            const sendFileId = file.id;
            this.sendFileFormControllerService.activateSendFileForm(sendFileId, true).subscribe();
          },
        );
        this.responseSuccessful("Service created!");
        this.resetSearch();
        this.initServices();
      },
      (error) => {
        this.isNewServiceLoading = false;
        this.showErrorMessage(error);
      },
    );
  }

  public toggleDropDown() {
    this.serviceDropdownClicked = !this.serviceDropdownClicked;
  }

  public toggleDownDownOff() {
    this.serviceDropdownClicked = false;
  }

  public showIconFor(service: any) {
    if (service.isLoading) {
      return "fad fa-spinner fa-spin";
    }
    if (service.active) {
      return "far fa-circle text-success";
    }
    return "fas fa-circle circle-toggle-off";
  }

  public getColorFor(service: any) {
    if (service.isLoading) {
      return "fa-spinner fa-spin";
    }
    if (service.active) {
      return "circle-green";
    }
    return "circle-gray";
  }

  public editService(service) {
    if (service.isMyAccountPage) {
      this.router.navigate(["/services/" + service.id + "/forms/applicant-form/"]);
    } else {
      this.router.navigate(["/services/" + service.id + "/registrations/"]);
    }
  }

  public toggleExtinList(service: any) {
    service.showExternalinList = !service.showExternalinList;
  }

  public toggleAllExtinList() {
    this.showExternalinList = !this.showExternalinList;
    this.services.forEach((service) => {
      service.showExternalinList = !service.showExternalinList;
    });
  }

  public toggleOperational(service: any, externalServer: any) {
    const serviceClone = _.cloneDeep(service);
    service.isLoading = true;
    if (!externalServer) {
      serviceClone.active = !serviceClone.active;
      this.serviceControllerService.activateService(service.id, serviceClone.active).subscribe(
        () => {
          if (serviceClone.active) {
            this.responseSuccessful("Service activated!");
          } else {
            this.responseSuccessful("Service inactivated!");
          }
          this.initServices();
        },
        (error) => {
          this.showErrorMessage(error);
          this.initServices();
        },
      );
    } else {
      externalServer.isLoading = true;
      externalServer.active = !externalServer.active;

      this.serviceControllerService.activateServiceExternal(service.id, externalServer).subscribe(
        () => {
          externalServer.isLoading = false;
          if (externalServer.active) {
            this.responseSuccessful("External service activated!");
          } else {
            this.responseSuccessful("External service inactivated!");
          }
          this.initServices();
        },
        (error) => {
          this.showErrorMessage(error);
          this.initServices();
        },
      );
    }
  }

  public showAddDeterminant() {
    this.isAddDeterminantShown = true;
    setTimeout(() => {
      this.newServiceNameInput.nativeElement.focus();
    }, 500);
  }

  public archiveService(service) {
    const serviceClone = _.cloneDeep(service);
    serviceClone.archived = !serviceClone.archived;
    service.isLoading = true;
    this.serviceControllerService.archiveService(serviceClone).subscribe(
      () => {
        if (serviceClone.archived) {
          this.responseSuccessful("Service archived!");
        } else {
          this.responseSuccessful("Service unarchived!");
        }
        this.initServices();
      },
      (error) => {
        this.showErrorMessage(error);
        this.initServices();
      },
    );

  }

  public isServiceSelected() {
    const url = this.router.url;
    return this.services && this.services.filter((it) => url.includes(it.id)).length > 0;
  }

  public serviceIsSelected(service) {
    if (!this.isServiceSelected()) {
      return false;
    }
    return this.getSelectedService().id === service.id;
  }

  public renameService(service) {
    service.isInRenameMode = true;
  }

  public cancelRename(service) {
    service.isInRenameMode = false;
    this.initServices();
  }

  public submitRename(service) {
    this.updateService(service, "Service renamed!");
  }

  public deleteService(service) {
    this.serviceControllerService.deleteService(service.id).subscribe(
      () => {
        this.responseSuccessful("Service deleted!");
        if (service.id === this.store.state.common.serviceId) {
          this.router.navigate(["/"]);
        } else {
          this.initServices();
        }
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public getGroupStatus(group) {
    return localStorage.getItem(`group-${group.name}`) === "true" ? true : false;
  }

  // A service is hidden from the current user when it is the predefined
  // "My Account Page" and the side nav is at level 1 (no access). Kept as a
  // single source of truth so the group badge count and the rendered item
  // visibility can never disagree.
  public isServiceHidden(service): boolean {
    return service?.isMyAccountPage && this.store.state.common.userLevels.pages.SideNavLevel === 1;
  }

  public getVisibleServicesCount(group): number {
    if (!group?.services) {
      return 0;
    }
    return group.services.filter((s) => !this.isServiceHidden(s)).length;
  }

  public toggleGroupStatus(group) {
    group.status = !group.status;
    localStorage.setItem(`group-${group.name}`, group.status ? "true" : "false");
  }

  private initServices() {
    this.isNewServiceLoading = false;
    this.isAddDeterminantShown = false;
    this.serviceDropdownClicked = false;
    this.newService = new Service();
    (this.router.url.indexOf("archived") > -1) ? this.archived = true : this.archived = false;
    this.serviceGroupControllerService.getAllServiceGroups().subscribe(
      (data) => {
        this.servicesGroups = data.sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        });
        const ungroupedGroup = new ServiceGroup();
        ungroupedGroup.id = null;
        ungroupedGroup.name = "Ungrouped services";
        ungroupedGroup.defaultStatus = this.systemProperties?.bpaProperties?.defaultGroupDefault ? this.systemProperties.bpaProperties.defaultGroupDefault : false;
        ungroupedGroup.status = localStorage.getItem(`group-${ungroupedGroup.name}`) ? this.getGroupStatus(ungroupedGroup) : ungroupedGroup.defaultStatus;
        ungroupedGroup.services = [];
        this.servicesGroups.push(ungroupedGroup);
        this.servicesGroups.forEach((g) => {
          g.loading = true;
          g.status = localStorage.getItem(`group-${g.name}`) ? this.getGroupStatus(g) : g.defaultStatus;
        });
        this.loadServices();
      },
      (err) => this.showErrorMessage(err),
    );
  }

  public loadServices() {
    this.serviceControllerService.getServicesList().subscribe(
      (data: Service[]) => {
        // console.log("--- services", data);
        this.loadServiceCategories();
        this.services = this.archived ? data.filter((d) => d.archived === true) : data.filter((d) => d.archived !== true);
        if (this.isServiceSelected()) {
          this.selectedServiceTitle = this.getSelectedService().name;
        } else {
          this.selectedServiceTitle = "Services available";
        }
        this.fillLastPublisher();
        this.fillServicesGroups();
        const servers = [];
        this.services.forEach((s) => {
          if (!s.serviceJsonProperties) {
            s.serviceJsonProperties = new ServiceProperties();
          }
          if (!s.serviceJsonProperties.guideType) {
            s.serviceJsonProperties.guideType = this.guideTypesOptions[2];
          }
          s.showExternalinList = false;
          if (s.isMyAccountPage) {
            this.defaultMyAccountServiceId = s.id;
            this.store.state.common.defaultMyAccountServiceId = this.defaultMyAccountServiceId;
            // console.log("defaultMyAccountServiceId", this.defaultMyAccountServiceId);
          }
          this.serviceControllerService.getServicesHistoryList(s.id).subscribe(
            (hist) => {
              s.publishHistory = _.orderBy(hist, "-date");
              s.publishHistory.forEach((h) => {
                h.opened = false;
                h.username = this.formatPublisher(h.username);
              });
              s.lastPublish = s.publishHistory.find((h) => {
                return !h.failReason && !h.destination;
              });
              if (s.lastPublish) {
                s.lastPublisher = this.formatPublisher(s.lastPublish.username);
              }
              if (s.statusesInExternalServers && s.statusesInExternalServers.length) {
                s.statusesInExternalServers.forEach((server) => {
                  this.externals ++;
                  if (servers.indexOf(server.externalServer.name) === -1) {
                    servers.push(server.externalServer.name);
                  }
                  server.lastPublish = s.publishHistory.find((h) => {
                    return !h.failReason && h.destination && h.destination === server.externalServer.name;
                  });
                  if (server.lastPublish) {
                    server.lastPublisher = this.formatPublisher(server.lastPublish.username);
                  }
                  // console.log(s);
                });
              }
            },
            (error) => this.showErrorMessage(error),
          );
        });
      },
      (err) => this.showErrorMessage(err),
    );
  }

  public fillServicesGroups() {
    this.servicesGroups.forEach((g) => {
      if (g.id) {
        g.services = this.services.filter((f) => {
          return f.serviceGroup?.id === g.id;
        });
      } else {
        g.services = this.services.filter((f) => {
          return !f.serviceGroup;
        });
      }
      g.services.sort((a, b) => {
        return a.sortOrder - b.sortOrder;
      });
      g.loading = false;
    });
  }

  public loadServiceCategories() {
    this.serviceCategoryControllerService.getAllServiceCategories().subscribe(
      (allCategories) => {
        this.allCategories = allCategories.sort((a, b) => {
          return Number(a.sortOrder) - Number(b.sortOrder);
        });
      },
    );
  }

  public filterByCategory(cat: any) {
    if (cat === "all") {
      this.selectedCat = cat;
      this.allCategories.forEach((c) => {
        c.selected = false;
      });
      this.isAcatSelected = null;
    } else {
      cat.selected = !cat.selected;
      this.isAcatSelected = this.allCategories.filter((c) => c.selected);
      if (!this.isAcatSelected.length) {
        this.selectedCat = "all";
        this.isAcatSelected = null;
      } else {
        this.selectedCat = "cat";
      }
    }
  }

  private fillLastPublisher() {
    this.services.forEach((item) => {
      item.lastPublisher = "";
      if (item.lastPublishedBy !== undefined && item.lastPublishedBy !== null) {
        if (item.lastPublishedBy.indexOf("(") !== -1) {
          item.lastPublisher = item.lastPublishedBy.slice(0, item.lastPublishedBy.indexOf("(") - 1);
        } else {
          item.lastPublisher = item.lastPublishedBy;
        }
      }
    });
  }

  private formatPublisher(publisher) {
    if (publisher !== undefined && publisher !== null) {
      if (publisher.indexOf("(") !== -1) {
        return publisher.slice(0, publisher.indexOf("(") - 1);
      } else {
        return publisher;
      }
    }
  }

  private getSelectedService() {
    const url = this.router.url;
    return this.services.filter((it) => url.includes(it.id))[0];
  }

  private updateService(serviceClone, successMessage) {
    this.serviceControllerService.saveService(serviceClone, null).subscribe(
      () => {
        this.responseSuccessful(successMessage);
        this.resetSearch();
        this.initServices();
      },
      (error) => {
        this.showErrorMessage(error);
        this.initServices();
      },
    );
  }

  private updateSortOrder(services, successMessage) {
    this.serviceControllerService.updateSortOrder(services).subscribe(
      () => {
        this.responseSuccessful(successMessage);
        this.resetSortVariables();
        this.initServices();

      },
      (error) => {
        this.showErrorMessage(error);
        this.initServices();
      },
    );
  }

  public searchTextChanged(value) {
    const filter = {};
    filter[this.nameFieldKey] = value;
    this.searchTextFilterObject = filter;
  }

  public resetSearch() {
    this.searchValue = "";
    this.searchTextFilterObject = null;
  }

  public submitInput(event) {
    const ENTER = 13;
    if (event.keyCode === ENTER) {
      if (this.newService.name && this.newService.name !== "" && this.addNew) {
        this.createService();
      }
    }
  }

  public sortServices(sortKey) {
    // if different key, start from ascending false
    this.ascending = sortKey !== this.sortKey ? false : this.ascending;
    // if same key third time clicking then reset sort
    this.resetSort = /*!this.ascending && sortKey === this.sortKey ? true : */false;
    if (!this.resetSort) {
      if (this.ascending) {
        this.services.sort((a, b) => (a[sortKey] != null ? new Date(a[sortKey]).valueOf() : 1) - (b[sortKey] != null ? new Date(b[sortKey]).valueOf() : -1));
      } else {
        this.services.sort((a, b) => (b[sortKey] != null ? new Date(b[sortKey]).valueOf() : -1) - (a[sortKey] != null ? new Date(a[sortKey]).valueOf() : 1));
      }
      // set the current sortKey
      this.sortKey = sortKey;
    } else {
      this.services.sort((a, b) => a.sortOrder - b.sortOrder);
      // set the current sortKey - none
      this.sortKey = "";
    }
    this.ascending = !this.ascending;
  }

  public resetSortVariables() {
    this.sortKey = "";
    this.ascending = false;
    this.resetSort = false;
  }

  public logoFileIdChanged(event: any) {
    if (event.cancelled) {
      this.showWarningMessage("Service import cancelled");
      return;
    }
    if (event.success) {
      this.responseSuccessful("Service imported successfully!");
      this.initServices();
      return;
    }
    // Legacy handling for backward compatibility
    if (event.status < 400 || event.save || event === "Service imported!") {
      this.responseSuccessful("Service imported successfully!");
      this.initServices();
    } else if (event.status >= 400 || event.message) {
      this.showErrorMessage(event);
    }
  }

  public goSeeService(service: Service, extUrl: string = null, copy: boolean = false) {
    let lang = this.store.state.common.lang;
    // @ts-ignore
    if (this.translateService._$supportedLangs && this.translateService._$supportedLangs.length > 0 && !this.translateService._$supportedLangs.includes(lang)) {
      // @ts-ignore
      lang = this.translateService._$supportedLangs[0];
    }
    let url;
    if (!environment.USE_NEW_DS) {
      url = environment.E_REGISTRATIONS_URL + lang + "/";
    } else {
      url = environment.E_REGISTRATIONS_URL;
    }
    if (extUrl?.length) {
      url = extUrl;
    }
    url = url.replace(/\/+$/, "") + "/";
    // String casting is here to fool TS, cause thee enum is miss used and actual keys are coming from server as values...
    if (!service?.isMyAccountPage) {
      // put back url ?attemptAutoLogin=1 at some point
      url += `${environment.USE_NEW_DS ? 'services' : 'services-new'}/${service.id}${environment.USE_NEW_DS ? '' : '?attemptAutoLogin=1'}`;
    }
    if (!copy) {
      window.open(url, "_blank");
    } else {
      navigator.clipboard.writeText(url);
      this.responseSuccessful("Service link copied to clipboard!");
    }
  }

  public openRCList(e) {
    this.selectedReleaseNotes = e;
    this.showReleaseNotes = true;
  }

  public closeRNdrawer() {
    this.selectedReleaseNotes = null;
    this.showReleaseNotes = false;
  }

}
